/**
 * Normalize dashboard tile URLs for `<a href>` — API may omit scheme or leading `/`.
 */
export function normalizeDashboardTileHref(raw: string | undefined | null): string {
  const u = (raw ?? '').trim()
  if (!u) return ''
  if (/^https?:\/\//i.test(u)) return u
  if (/^\/\//.test(u)) return `https:${u}`
  if (/^(mailto:|tel:)/i.test(u)) return u
  if (u.startsWith('/')) return u
  if (/^[a-z][a-z0-9+.-]*:/i.test(u)) return u
  return `/${u.replace(/^\/+/, '')}`
}
